import { MaybeMatch } from '@nf/utils-common/fpw/monadic';
import { stringEmptyCheck } from '@nf/utils-common/fpw/utils';
import { ReactNode } from 'react';
import { TeamLogo } from '../team-logo';
import clsx from 'clsx';
import { useAppearanceStore } from '@/store/appearance';

interface TeamCardProps {
	teamId: number;
	teamType: 'H' | 'A';
    teamName: string;
    score: string;
    isLive: boolean;
	dotTemplate?(): ReactNode;
	redCardCount?: number;
	isStrong: boolean;
}

export const TeamCard = ({ 
	teamId, 
	teamType,
	teamName, 
	score, 
	isLive, 
	dotTemplate, 
	redCardCount,
	isStrong
}: TeamCardProps) => {
	const [oddsPageLayout] = useAppearanceStore((state) => [state.oddsPageLayout, state.fontSize]);

	return (
		<div className={clsx('match-team', {
			'match-team__strong': isStrong
		})}
		>
			{
				dotTemplate && dotTemplate()
			}
			
			{oddsPageLayout === 'list' &&  
				<TeamLogo 
					teamType={teamType}
					teamId={teamId}
					className="match-team__flag"
				/>
			}

			<div className="match-team__name">{teamName}</div>
			{ redCardCount && redCardCount > 0 ? <div className="red-card">{redCardCount}</div>: null}
			{
				MaybeMatch(isLive)
					.chain(() => stringEmptyCheck(score))
					.fold(
						() => {},
						() => <div className="match-team__score">{score}</div>
					)
			}
		</div>
	);
};